import React from "react";
import "./styled.scss";
import { useContext, useState } from "react";
import emailjs from "emailjs-com";
import { Form } from "react-bootstrap";

import loadingConsulta from "../../assets/img/preloader.gif";
import { VehiculosContext } from "../../context/VehiculosContext";
import ModalWarning from "../ModalWarning/ModalWarning";

import banderaArgentina from "../../assets/img/landing-cronos/bandera-argentina.png";
import checkCircle from "../../assets/img/landing-cronos/check-circle.svg";
import check from "../../assets/img/checkEnviado.png";
import { sendPostRequest } from "../../config/desol";

export const FormularioNuevo = ({
  vMarca,
  vModelo,
  filtrados,
  autoSeleccionado,
  tipo,
  setFormularioConInformacion,
  handleClose,
  handleShow,
  handleCloseAll,
  handleShowWarning,
}) => {
  const { marcaLanding, modeloLanding } = useContext(VehiculosContext);

  const vehiculoSeleccionado = vModelo ? vModelo : "No Seleccionado";

  // leeo en sessionStorage los utm_source y utm_medium
  const utm_source = sessionStorage.getItem("utm_source") || "sin_utm_source";
  const utm_medium = sessionStorage.getItem("utm_medium") || "sin_utm_medium";
  // fin leeo en sessionStorage los utm_source y utm_medium
  const [desolChannel, setDesolChannel] = useState("C12_FIAT_JEEP_PEUGEOT_LANDINGS");
  const [tipoTemplate, setTipoTemplate] = useState("landing_fiat_cronos_conv");

  const [status, setStatus] = useState(null);
  const [toSend, setToSend] = useState({
    name: "",
    email: "",
    phone: "",
    comments: "",
    medio: "Llamada",
    horario: "",
    vehicle: `${vMarca ? vMarca : ""} ${vehiculoSeleccionado}`,
    origen: `${utm_source ? utm_source : ""}  ${utm_medium ? utm_medium : ""}`,
    tipo: `${marcaLanding}_${modeloLanding}`,
  });

  const [showWarning, setShowWarning] = useState(false);

  const [validated, setValidated] = useState(null);

  const handleCloseWarning = () => setShowWarning(false);

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
    /*if (toSend.name !== "" || toSend.email !== "" || toSend.phone !== "") {
        setShowWarning(true);
    } else {
        setShowWarning(false);
    }
    */

    if (tipo === "plan") {
      setTipoTemplate("landing_fiat_cronos_plan");
    } else {
      setTipoTemplate("landing_fiat_cronos_conv");
    }
  };

  // const onSubmit = (e) => {
  //   const form = e.currentTarget;

  //   if (form.checkValidity() === false) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     setValidated(true);
  //     console.log("no validado", form);
  //   }
  //   if (form.checkValidity() === true) {
  //     //setValidated(true);
  //     e.preventDefault();
  //     setStatus("cargando");
  //     emailjs
  //       .send("landingMontironi", "template_directa_cronos", toSend, "user_EIC1ELQk7I3NPaFMEDa64")
  //       .then((response) => {
  //         setStatus("ok");

  //         setTimeout(() => {
  //           setStatus(null);
  //           setToSend({
  //             ...toSend,
  //             name: "",
  //             email: "",
  //             phone: "",
  //             comments: "",
  //             medio: "",
  //             horario: "",
  //             vehicle: "",
  //             origen: "",
  //             tipo: "",
  //           });
  //           window.location.href = "https://marketing.montironi.com/cronos/";
  //         }, 3000);
  //       })
  //       .catch((err) => {
  //         setStatus("error");
  //         setTimeout(() => {
  //           setStatus(null);
  //         }, 60000);
  //       });
  //   }
  // };

  const onSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior at the start

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();

      return;
    }

    setStatus("cargando");
    setValidated(true);

    const data = {
      Apellido: toSend.name,
      Email: toSend.email,
      Telefono: toSend.phone,
      Canal: tipo === "plan" ? "Plan de ahorro" : "Venta directa",
      Motivo: toSend.comments,
      OrigenLead: `${process.env.REACT_APP_LANDING} - ${utm_source}`,
      CommercialCampaign: utm_medium,
      Campaign: desolChannel,
      Modelo_Pedido: toSend.vehicle,
    };
    // EMAIL JS (ONLY FOR BACKUP)
    emailjs.send("landingMontironi", "template_directa_cronos", toSend, "user_EIC1ELQk7I3NPaFMEDa64");

    // API DESOL
    sendPostRequest(process.env.REACT_APP_DESOL_URL, data)
      .then((response) => {
        setStatus("ok");
        setTimeout(() => {
          setValidated(false);
          setToSend({
            ...toSend,
            name: "",
            email: "",
            phone: "",
            comments: "",
            medio: "",
            horario: "",
            vehicle: "",
            origen: "",
          });
          window.location.href = "https://marketing.montironi.com/cronos/";
        }, 10000);
      })
      .catch((error) => {
        setStatus("error");
        setTimeout(() => {
          setStatus(null);
        }, 10000);
      });
  };

  return (
    <div className="formularioContenedor">
      {status === null ? (
        <div>
          <h1>
            {" "}
            <img src={checkCircle} alt="Icon Check" /> Tu modelo elegido es: <b>{vModelo}</b>
          </h1>

          <Form onSubmit={onSubmit} noValidate className={validated ? "was-validated" : ""}>
            <div className="cajasInputs">
              <label>Nombre y apellido*</label>
              <Form.Control
                placeholder="Nombre y apellido"
                id="name"
                name="name"
                type="text"
                value={toSend.name}
                onChange={handleChange}
                required
              />
              <Form.Control.Feedback type="invalid">Por favor, ingrese su nombre y apellido.</Form.Control.Feedback>
            </div>
            <div className="inputAlaMitad">
              <div className="cajasInputs">
                <label>Nro de Celular*</label>
                <div className="contenedorInputBander">
                  <div className="contenedorInputBander-input">
                    <img src={banderaArgentina} alt="Bandera Argentina" />
                    <span>+549</span>
                  </div>
                  <Form.Control
                    id="phoneValidar"
                    name="phone"
                    type="number"
                    placeholder="351 5898989"
                    value={toSend.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <span className="spanTelefonoColor">Ingresá tu número sin 0 y sin 15.</span>
              </div>
              <div className="cajasInputs">
                <label>E-mail*</label>
                <Form.Control
                  id="email"
                  name="email"
                  type="email"
                  className="input-new-Formulario"
                  placeholder="ejemplo@gmail.com.ar"
                  value={toSend.email}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">Por favor, ingrese su email.</Form.Control.Feedback>
              </div>
            </div>
            <div className="cajasInputs">
              <label>Dejanos tu consulta</label>
              <textarea
                placeholder="Hola, quiero información sobre este modelo"
                name="comments"
                id="comments"
                rows="2"
                onChange={handleChange}
                value={toSend.comments}
              ></textarea>
            </div>

            <div className="mt-5">
              <button type="submit" className="btnEnviar">
                Enviar consulta
              </button>
            </div>
          </Form>
        </div>
      ) : null}
      {status === "cargando" && (
        <div className="msgHeader text-center pt-5 pb-5" id="enviando-mensaje">
          <img src={loadingConsulta} alt="Cargando..." className="pb-3" width={250} />
          <p className="texto-loading-consulta">Estamos enviando tu consulta...</p>
        </div>
      )}

      {status === "ok" && (
        <div className="msgHeader text-center pt-5 pb-5" id="mensaje-enviado">
          <div>
            <img src={check} alt="Enviado" className="img-fluid" style={{ marginBottom: "20px", maxWidth: "60px" }} />
            <p className="titulo-formulario-enviado">¡Listo! ya enviamos tu solicitud.</p>
            <p className="subtitulo-formulario-enviado">Un asesor se contactará con vos a la brevedad. </p>
            <p className="parrafo-formulario-enviado">Ya podes cerrar ésta pestaña.</p>
          </div>
        </div>
      )}

      {status === "error" && (
        <div className="msgHeader pt-5 pb-5" id="mensaje-error">
          <div>
            <p
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "22px",
                marginBottom: "0",
                textAlign: "center",
              }}
            >
              Se ha producido un error
            </p>
            <p style={{ textAlign: "center" }}>Vuelva a intentarlo mas tarde</p>
          </div>
        </div>
      )}

      <ModalWarning show={showWarning} handleClose={handleCloseWarning} closeAll={handleCloseAll} />
    </div>
  );
};
